function safeCompute({
  method,
  fallback,
  logger
}) {
  try {
    return method();
  } catch (error) {
    if (logger) logger(error);
    return fallback;
  }
}
export {
  safeCompute
};
//# sourceMappingURL=safe-compute.js.map
